import { useCallback } from 'react';
import { transformAmountHieDcTotal } from '../../utils';

export const useTransformAmountHieDcTotal = (qt: number | null | undefined, date: Date) => {
  const transformAmountHieDcTotalFn = useCallback(transformAmountHieDcTotal(qt, date), [qt, date]);
  return transformAmountHieDcTotalFn;
};
